<template lang="html">
  <div class="">
    <h1 class="pl-display-3 school-name">{{ school_name }}</h1>
    <div class="meta-data-on-school pl-display-1">
      <p>
        Data last fetched:
        <span class="b">{{ summary_meta_data.last_fetched }}</span>
      </p>
      <p>
        {{
          summary_meta_data.queried_email
            ? 'Reporting for queried email containing: '
            : 'Reporting for teachers officially assigned to this school ID in the database'
        }}
        <span class="b italics">{{ summary_meta_data.queried_email }}</span>
      </p>
    </div>
    <!-- .meta-data-on-school -->
    <div class="email-query-input flex items-center">
      <pl-input
        @keyup.enter="getSetAllSummaryData"
        v-model="email_handle_query"
      ></pl-input>
      <div>
        <button
          @click="getSetAllSummaryData"
          class="grow ba--solid bw1 br3 ttu pv2 ph3 ripple purple b b--purple"
        >
          run numbers with email
        </button>
      </div>
    </div>
    <!-- .email-query-input -->
    <table class="teacher-student-data tc" style="display: inline-block">
      <tr>
        <th>Total Teachers</th>
        <th>Enrolled Students</th>
      </tr>
      <tr>
        <td>{{ users.length }}</td>
        <td>{{ number_of_students_enrolled }}</td>
      </tr>
    </table>
    <!-- .teacher-student-data -->

    <!-- Active teachers and students -->
    <table class="tc" style="display: inline-block">
      <tr>
        <th>Date</th>
        <th>Active Teachers</th>
        <th>Active Students</th>
      </tr>
      <tr>
        <td style="font-size: 16px">
          <label for="start">Start date:</label>
          <input
            type="date"
            v-model="active_filter.start_date"
            id="active-start"
            name="active-start"
          />
          <br />
          <label for="start">End date:</label>
          <input
            type="date"
            v-model="active_filter.end_date"
            id="active-end"
            name="active-start"
          />
          <br />
          <pl-button
            :disabled="!(active_filter.start_date && active_filter.end_date)"
            @click.native="calculateActiveTeachersAndStudents"
            class="pl-primary"
          >
            Calculate
          </pl-button>
        </td>
        <td>{{ active_info.teachers }}</td>
        <td>{{ active_info.students }}</td>
      </tr>
    </table>

    <div class="filters-for-data flex items-center">
      <div class="participant-minimums pl-subheading">
        <div class="flex items-center justify-between">
          Minimum invited to Written
          <pl-input
            :centeredText="true"
            type="number"
            style="width: 100px"
            v-model="filter_minimum_online_invites"
          />
        </div>
        <div class="flex items-center justify-between">
          Minimum invited to Verbal
          <pl-input
            :centeredText="true"
            type="number"
            style="width: 100px"
            v-model="filter_minimum_live_invites"
          />
        </div>
      </div>
      <!-- .participant-minimums -->
      <div class="participant-minimums pl-subheading">
        <div class="flex items-center justify-between">
          Minimum participated in Written
          <pl-input
            :centeredText="true"
            type="number"
            style="width: 100px"
            v-model="filter_minimum_online_submitted"
          />
        </div>
        <div class="flex items-center justify-between">
          Minimum participated in Verbal
          <pl-input
            :centeredText="true"
            type="number"
            style="width: 100px"
            v-model="filter_minimum_live_participated"
          />
        </div>
      </div>
      <!-- .participant-minimums -->

      <div class="date-pickers pl-subheading date-pickers ml4">
        <div class="flex items-center justify-between">
          Start Date
          <pl-input :centeredText="true" type="date" v-model="start_date" />
        </div>
        <div class="flex items-center justify-between">
          End Date
          <pl-input :centeredText="true" type="date" v-model="end_date" />
        </div>
      </div>
      <!-- .date-pickers -->
    </div>
    <!-- .filters-for-data -->

    <table class="roundtable-discussion-data tc">
      <tr>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Active Teachers</th>
        <th>Written RoundTables</th>
        <th>Written Participation Rate</th>
        <th>Verbal RoundTables</th>
        <th>Verbal Participation Rate</th>
        <th>Universe RoundTables</th>
      </tr>
      <tr>
        <!-- Report Date -->
        <td>{{ report_start_date }}</td>
        <td>{{ report_end_date }}</td>
        <td>{{ number_of_active_teachers }}</td>
        <!-- Online RoundTables Count -->
        <td>{{ online_roundtable_count }}</td>
        <!-- Online RoundTables Participation-->
        <td>{{ online_roundtable_participation_rate }}</td>
        <!-- Live Discussion Count-->
        <td>{{ live_discussion_count }}</td>
        <!-- Live Discussion Participation-->
        <td>{{ live_discussion_participation_rate }}</td>
        <!-- Universe RoundTable Count -->
        <td>{{ premade_count }}</td>
      </tr>
    </table>
    <!-- .roundtable-discussion-data -->

    <section class="discussion-info-card-section flex mt5 mw8">
      <div class="online-side w-50">
        <p v-if="filtered_online_data.length" class="pl-title tc blue">
          WRITTEN ROUNDTABLES
        </p>
        <div
          v-for="rt in filtered_online_data"
          class="pa1 tl w-100 grow relative"
        >
          <div
            v-if="rt.is_premade"
            class="absolute top-1 right-1 pl-title italics"
          >
            PREMADE
          </div>
          <table class="ma1 shadow-1 pa3 w-100 rt-info-card br4">
            <tr class="pl-title blue">
              {{
                dateFormatted(rt.discussion_created_date)
              }}
            </tr>
            <tr class="pl-subheading">
              {{
                rt.roundtable_title
              }}
            </tr>
            <tr>
              {{
                rt.author_name
              }}
            </tr>
            <tr>
              {{
                rt.author_email
              }}
            </tr>
            <tr>
              {{
                rt.submitted
              }}
              submitted
            </tr>
            <tr>
              {{
                rt.count_invited
              }}
              invited
            </tr>
          </table>
        </div>
      </div>
      <div class="w-50 ml5">
        <p v-if="filtered_live_data.length" class="pl-title tc red">
          VERBAL DISCUSSIONS
        </p>
        <div v-for="rt in filtered_live_data" class="pa1 tl w-100 grow">
          <table class="ma1 shadow-1 pa3 w-100 rt-info-card br4">
            <tr class="pl-title red">
              {{
                dateFormatted(rt.discussion_created_date)
              }}
            </tr>
            <tr class="pl-subheading">
              {{
                rt.live_discussion_title
              }}
            </tr>
            <tr>
              {{
                rt.author_name
              }}
            </tr>
            <tr>
              {{
                rt.author_email
              }}
            </tr>
            <tr>
              {{
                rt.number_participated
              }}
              participated
            </tr>
            <tr>
              {{
                rt.number_invited
              }}
              invited
            </tr>
          </table>
        </div>
      </div>
    </section>
    <!-- discussion-info-card-section -->
  </div>
</template>
<script>
  import adminServices from 'services/admin/adminServices';
  import moment from 'moment';
  import uniqBy from 'lodash/uniqBy';

  export default {
    data() {
      return {
        active_filter: {
          start_date: '',
          end_date: '',
        },
        active_info: {
          teachers: 0,
          students: 0,
        },
        filter_minimum_online_invites: 2,
        filter_minimum_live_invites: 2,
        filter_minimum_online_submitted: 0,
        filter_minimum_live_participated: 0,
        number_of_students_enrolled: 0,
        online_roundtable_summary: [],
        live_discussion_summary: [],
        users: [],
        start_date: null,
        end_date: null,
        email_handle_query: '',
        summary_meta_data: {
          last_fetched: null,
          queried_email: null,
        },
      };
    },
    computed: {
      school_name() {
        return this.$route.query.name;
      },
      number_of_active_teachers() {
        const online_plus_live_data = this.online_roundtable_summary.concat(
          this.live_discussion_summary
        );
        const uniqueUsers = uniqBy(online_plus_live_data, 'author_email');
        return uniqueUsers.length;
      },
      report_start_date() {
        return this.start_date
          ? moment(this.start_date).format('MMM Do[,] YYYY')
          : 'no date selected';
      },
      report_end_date() {
        return this.end_date
          ? moment(this.end_date).format('MMM Do[,] YYYY')
          : 'no date selected';
      },
      filtered_live_data() {
        let filtered_data = JSON.parse(
          JSON.stringify(this.live_discussion_summary)
        );
        // filter by number of invited
        if (this.filter_minimum_live_invites) {
          filtered_data = filtered_data.filter(
            (rt) =>
              Number(rt.number_invited) >= this.filter_minimum_live_invites
          );
        }
        // filter by number of invited
        if (this.filter_minimum_live_participated) {
          filtered_data = filtered_data.filter(
            (rt) =>
              Number(rt.number_participated) >=
              this.filter_minimum_live_participated
          );
        }
        // filter by date
        if (this.start_date) {
          filtered_data = filtered_data.filter((rt) =>
            moment(rt.discussion_created_date, moment.ISO_8601).isAfter(
              this.start_date
            )
          );
        }
        if (this.end_date) {
          filtered_data = filtered_data.filter((rt) =>
            moment(rt.discussion_created_date, moment.ISO_8601).isBefore(
              moment(this.end_date, moment.ISO_8601).endOf('day')
            )
          );
        }
        return filtered_data;
      },
      filtered_online_data() {
        let filtered_data = JSON.parse(
          JSON.stringify(this.online_roundtable_summary)
        );
        // filter by number of invited
        if (this.filter_minimum_online_invites) {
          filtered_data = filtered_data.filter(
            (rt) =>
              Number(rt.count_invited) >= this.filter_minimum_online_invites
          );
        }
        // filter by number of invited
        if (this.filter_minimum_online_submitted) {
          filtered_data = filtered_data.filter(
            (rt) => Number(rt.submitted) >= this.filter_minimum_online_submitted
          );
        }
        // filter by date
        if (this.start_date) {
          filtered_data = filtered_data.filter((rt) =>
            moment(rt.discussion_created_date, moment.ISO_8601).isAfter(
              this.start_date
            )
          );
        }
        if (this.end_date) {
          filtered_data = filtered_data.filter((rt) =>
            moment(rt.discussion_created_date, moment.ISO_8601).isBefore(
              moment(this.end_date, moment.ISO_8601).endOf('day')
            )
          );
        }
        return filtered_data;
      },
      live_discussion_count() {
        return this.filtered_live_data.length;
      },
      online_roundtable_count() {
        return this.filtered_online_data.length;
      },
      live_discussion_participation_rate() {
        const participation_rates_by_rt = this.filtered_live_data.map(
          (rt) => rt.number_participated / rt.number_invited
        );
        const summed_rates = participation_rates_by_rt.reduce(
          (previousValue, currentValue) => {
            return previousValue + currentValue;
          },
          0
        );
        const average_participation_rate =
          summed_rates / participation_rates_by_rt.length;
        return Math.round(average_participation_rate * 100) + '%';
      },
      online_roundtable_participation_rate() {
        const participation_rates_by_rt = this.filtered_online_data.map(
          (rt) => rt.submitted / rt.count_invited
        );
        const summed_rates = participation_rates_by_rt.reduce(
          (previousValue, currentValue) => {
            return previousValue + currentValue;
          },
          0
        );
        const average_participation_rate =
          summed_rates / participation_rates_by_rt.length;
        return Math.round(average_participation_rate * 100) + '%';
      },
      premade_count() {
        return this.filtered_online_data.filter((rt) => rt.is_premade).length;
      },
    },
    methods: {
      dateFormatted(dateAsString) {
        return moment(dateAsString).format('MMM Do[,] YYYY');
      },
      getSetOnlineSummaryData() {
        return adminServices
          .getSchoolOnlineRoundtableSummary(
            this.$route.params.schoolID,
            this.email_handle_query
          )
          .then(({ data }) => {
            this.online_roundtable_summary = data;
          })
          .catch(console.error);
      },
      getSetLiveSummaryData() {
        return adminServices
          .getSchoolLiveDiscussionSummary(
            this.$route.params.schoolID,
            this.email_handle_query
          )
          .then(({ data }) => {
            this.live_discussion_summary = data;
          })
          .catch(console.error);
      },
      getSetTeachersData() {
        if (this.email_handle_query) {
          return adminServices
            .getUsersByEmail(this.email_handle_query, 'teacher')
            .then(({ data }) => {
              this.users = data;
            })
            .catch(console.error);
        }
        return adminServices
          .getUsersOfSchool(this.$route.params.schoolID)
          .then(({ data }) => {
            this.users = data.users;
          })
          .catch(console.error);
      },
      getSetStudentsData() {
        return adminServices
          .getNumberStudentsEnrolled(
            this.$route.params.schoolID,
            this.email_handle_query
          )
          .then(({ data }) => {
            this.number_of_students_enrolled = data[0].number_of_students;
          })
          .catch(console.error);
      },
      getSetAllSummaryData() {
        Promise.all([
          this.getSetOnlineSummaryData(),
          this.getSetLiveSummaryData(),
          this.getSetTeachersData(),
          this.getSetStudentsData(),
        ])
          .then(() => {
            this.summary_meta_data = {
              last_fetched: moment().format('MMM Do[,] YYYY'),
              queried_email: this.email_handle_query,
            };
          })
          .catch(console.error);
      },
      calculateActiveTeachersAndStudents() {
        const { start_date, end_date } = this.active_filter;
        adminServices
          .getActiveTeachersAndStudents(
            this.$route.params.schoolID,
            this.email_handle_query,
            {
              start_date,
              end_date,
            }
          )
          .then((res) => {
            this.active_info = res.data;
          })
          .catch(console.error);
      },
    },
    mounted() {
      this.getSetAllSummaryData();
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  table:not(.rt-info-card)
    border: 2px solid pl-fog
    border-radius: 3em;
    padding: 2em;
  th, td
    padding: 1em;
  td
    font-size: 150%
</style>



// WEBPACK FOOTER //
// schoolEngagementSummary.vue?53444410